// @flow

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import I18n from '../../i18n/I18n';


import TaxesType from '../../constants/TaxesType';

// -- views
import LocalizableSelect from './LocalizableSelect';

export default class VatChooser extends Component {

  static defaultProps = {
    clearable: true,

    readOnly: false
  };

  static propTypes = {
    value: PropTypes.number.isRequired,

    // param: number, the chosen vat
    onChange: PropTypes.func.isRequired,

    clearable: PropTypes.bool,

    readOnly: PropTypes.bool
  };

  onSelect = (option) => {
    if (_.isNull(option)) {
      this.props.onChange(0);
    } else {
      this.props.onChange(option.value)
    }
  };

  render() {
    const taxesChoices = TaxesType.getChoices();

    return (
      <div className="vat_chooser">
        <LocalizableSelect
          name="action"
          value={this.props.value}
          options={taxesChoices}
          onChange={this.onSelect}
          clearable={this.props.clearable}
          placeholder={I18n.tr('components.vat_chooser.placeholder')}
          disabled={this.props.readOnly}
        />
      </div>
    );
  }

}
